/**
 * Notification Bars Table Component
 * 
 * @package TopBuddy
 */

import { Card, CardBody } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import TableRow from './TableRow';

const NotificationBarsTable = ({ posts, activeBarIds, isPro, onToggle, onDelete, onDuplicate }) => {
	return (
		<Card>
			<CardBody>
				<table className="widefat fixed topbuddy-table">
					<thead>
						<tr>
							<th className="topbuddy-table-title-header">
								{__('Title', 'topbuddy')}
							</th>
							<th className="topbuddy-table-status-header">
								{__('Status', 'topbuddy')}
							</th>
							<th className="topbuddy-table-active-header">
								{__('Active', 'topbuddy')}
							</th>
						</tr>
					</thead>
					<tbody>
						{posts.map((post) => (
							<TableRow
								key={post.id}
								post={post}
								isActive={activeBarIds.includes(post.id)}
								isPro={isPro}
								onToggle={onToggle}
								onDelete={onDelete}
								onDuplicate={onDuplicate}
							/>
						))}
					</tbody>
				</table>
			</CardBody>
		</Card>
	);
};

export default NotificationBarsTable;

